export interface FlipCardImages {
  left?: string | null | undefined;
  right?: string | null | undefined;
}
